

const stripHtml = (html = '') => {
    if (typeof html !== 'string') return String(html ?? '')
    return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
}

export const makePreview = (htmlOrText, truncateLength = 14) => {
    const txt = stripHtml(htmlOrText)
    if (!txt) return '—'
    return txt.length > truncateLength ? txt.slice(0, truncateLength) + '...' : txt
}


// Format date nicely
export const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}

export const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('deviceId');

    if (!deviceId) {
        try {
            deviceId = crypto.randomUUID();
        } catch (error) {
            deviceId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}${Math.random().toString(36).substring(2, 15)}`;
        }
        localStorage.setItem('deviceId', deviceId);
    }

    return deviceId;
};

